import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { WithdrawalReceiptPage } from 'src/app/shared/modals/withdrawal-receipt/withdrawal-receipt.page';
import { AuthenticationService } from 'src/app/shared/_services';
import { DashboardStore, WithdrawStore } from 'src/app/shared/_services/store';

@Component({
  selector: 'app-withdrawal-history',
  templateUrl: './withdrawal-history.page.html',
  styleUrls: ['./withdrawal-history.page.scss'],
})
export class WithdrawalHistoryPage implements OnInit {
  withdrawalHistoryDetails = [];
  today = Date.now();
  sort = false;
  epochDateTime = new Date ().getTime();
  subscription: any;
  gettingWithdrawals = false;

  constructor(
    private router: Router,
    private platform: Platform,
    private auth: AuthenticationService,
    private withdrawStore: WithdrawStore,
    private dashboardStore: DashboardStore,
    private modalController: ModalController
  ) { }

  hideText() {
    this.sort = true;
  }

  showText() {
    this.sort = false;
  }

  changeDate(ev: any) {
    console.log(ev.detail.value);
    const date = ev.detail.value;
    this.epochDateTime = new Date (date).getTime();
    console.log(this.epochDateTime);
    this.getWithdrawalHistory();
  }

  getWithdrawalHistory() {
    this.gettingWithdrawals = true;
    this.auth.withdrawalHistory(this.epochDateTime).subscribe(
      response => {
        this.gettingWithdrawals = false;
        console.log(response);
        this.withdrawStore.setWithdrawalHistoryDetails(response);
        this.withdrawalHistoryDetails = this.withdrawStore.getWithdrawalHistoryDetails();
        this.withdrawStore.setIsHistoryChecked(true);
      },
      error => {
        console.log(error);
      }
    );
  }

  async openWithdrawalHistoryDetail(withdrawalHistoryDetail: any) {
    console.log(withdrawalHistoryDetail);
    const modal = await this.modalController.create({
      component: WithdrawalReceiptPage,
      backdropDismiss: true,
      showBackdrop: true,
      swipeToClose: true,
      // mode: 'ios',
      cssClass: 'bottom-modal create-dispute',
      componentProps: { withdrawalHistoryDetail }
    });
    return await modal.present();
  }

  goBack() {
    this.router.navigateByUrl('/withdraw');
  }

  ionViewWillEnter() {
    document.title = 'Withdrawal History | Bank3D';
  }

  ionViewDidEnter() {
    this.subscription = this.platform.backButton.subscribeWithPriority(99999, () => {
      this.goBack();
    });
  }

  ionViewDidLeave() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    console.log(this.epochDateTime);
    this.getWithdrawalHistory();
    if (this.withdrawStore.getIsHistoryChecked()) {
      this.withdrawalHistoryDetails = this.withdrawStore.getWithdrawalHistoryDetails();
    }
  }
}
